import React, { useState, useEffect } from 'react';
import PageHeading from '../../components/PageHeading';
import { SearchOutlined, EditOutlined, DeleteOutlined, LineHeightOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';
import { Button, Input, message, Popconfirm, Table, Tag } from 'antd';
import { dateFormat } from '../../utils/dateFormats';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';

const News = () => {
	const navigate = useNavigate();
	const [news, setNews] = useState({
    current_page: 1,
    page_size: 20,
		results: []
	});
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [search, setSearch] = useState('');

	useEffect(() => {
		const delayFetch = debounce(() => {
			fetchData();
		}, 550); // 550ms debounce

		delayFetch();
		
		return () => delayFetch.cancel();

		// eslint-disable-next-line
	}, [search, page]);

	const handleSearch = (e) => {
		setSearch(e.target.value);
		setPage(1);
	}

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get(`news_and_events/news/?page=${page}&search=${search}`);
			setNews(response.data);
		} catch (error) {
			message.error("Failed to fetch news");
		} finally {
			setLoading(false);
		}
	};

	const cancel = () => message.info('Cancelled');

	const confirm = async (id) => {
		try {
			await axiosInstance.delete(`news_and_events/news/${id}/`);
			message.success("Deleted successfully");
			setPage(1);
			fetchData();
		} catch (err) {
			message.error("Cannot delete");
		}
	};

	const columns = [
		{
			title: 'Heading',
			dataIndex: 'heading',
			key: 'heading',
			render: (text) => {
				const minLength = 15;
				const shouldTruncate = text.length > minLength;
				const displayText = shouldTruncate ? text.slice(0, minLength) + '...' : text;

				return (
					<span title={shouldTruncate ? text : ''}>
						{displayText}
					</span>
				);
			}
		},
		{
			title: 'Created at',
			dataIndex: 'created_at',
			key: 'created_at',
			render: text => dateFormat(text),
		},
		{
			title: 'Status',
			dataIndex: 'publish',
			key: 'publish',
			render: (_, record) => record.publish === true ? <Tag color="success">Published</Tag> :  <Tag color="warning">Hidden</Tag>,
		},
		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => (
				<>
					<Button type="link" icon={<EditOutlined />}  onClick={() => navigate(`/admin/update-news/${record.id}`)} />
					<Popconfirm
						title="Delete"
						description="Are you sure to delete this item?"
						onConfirm={() => confirm(record.id)}
						onCancel={cancel}
						okText="Yes"
						cancelText="No"
					>
						<Button type="link" danger icon={<DeleteOutlined />} />
					</Popconfirm>
				</>
			)
		},
	];

	return (
		<div className='dashboard'>
			<PageHeading name="News" icon={<LineHeightOutlined/>} />

			<div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
				<Input
					placeholder="Search here"
					prefix={<SearchOutlined />}
					style={{ width: "190px" }}
					onChange={(e) => handleSearch(e)}
				/>
				<Button type="primary" onClick={() => navigate('/admin/add-news')}>Add new</Button>
			</div>

			<Table
				dataSource={news.results}
				loading={loading}
				columns={columns}
				rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination={{
					current: page,
					pageSize: 20,
					total: news.count,
					onChange: (newPage, _) => {
						setPage(newPage);
					}
				}}
			/>
		</div>
	)
}

export default News